// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"icon-module--wrapper--2lc6M","svg":"icon-module--svg--b7LrK","title":"icon-module--title--2zPj3","subtitle":"icon-module--subtitle--2vJW-"};